import { RowDataBuildConfigCustom } from "../../components/BuildConfigCustomPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the BuildConfigCustomTable factory
 */
class BuildConfigCustomRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/build-config/read-range-custom"
        this.accessData = "builds"
    }

    create(build: any): RowDataBuildConfigCustom {
        const rowDataCustom: RowDataBuildConfigCustom = {
            id: build.id,
            buildId: build.buildId,
            title: build.title,
            images: build.images,
            cpu: build.cpu,
            cooler: build.cooler,
            gpu: build.gpu,
            mobo: build.mobo,
            case: build.case,
            ram: build.ram,
            psu: build.psu,
            ssd1: build.ssd1,
            ssd2: build.ssd2,
            isPrebuild: build.isPrebuild,
            isCustom: build.isCustom,
            isEasy: build.isEasy,
            show: build.show,

            action: "",
        };
        return rowDataCustom;
    }
}

let buildConfigCustomRow: BuildConfigCustomRow | null = null;

export default function getBuildConfigCustomRow(): BuildConfigCustomRow {
    if (buildConfigCustomRow === null)
        buildConfigCustomRow = new BuildConfigCustomRow()
    return buildConfigCustomRow
}